import { useEffect, useState } from "react";
import CommitteeIcon from "../../assets/svg/committee-icon.svg";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { committeeActions } from "../../_store/committee.slice";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { history } from "../../_helpers";
import CustomLoader from "../../components/common/ui/Loader";

function ViewAllCommittees() {
  const dispatch = useDispatch();

  const [committeeList, setCommitteeList] = useState([]);
  const [seacrhCommitteelist, setSeacrhCommitteelist] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPage, settotalPage] = useState(1);
  const isLoggedin = JSON.parse(sessionStorage.getItem("isLoggedIn"));

  useEffect(() => {
    getCommitteeListForSlider();
  }, [dispatch]);

  const getCommitteeListForSlider = () => {
    setLoader(true);
    dispatch(committeeActions?.sliderForHomePage("limit=100"))
      .then((result) => {
        if (result?.payload?.status === 1) {
          setLoader(false);
          // settotalPage(result?.payload?.data?.totalPages);
          setCommitteeList(result?.payload?.data?.committees || []);
          setSeacrhCommitteelist(result?.payload?.data?.committees || []);
        }
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
        showToastNotification("Failed to load committees list", "error");
      });
  };

  const handleCardClick = (item) => {
    history?.navigate(`/Committee/${item?._id}`, {
      state: { committeeID: item },
    });
  };

  const searchCommittees = (e) => {
    debugger;
    const { value } = e?.target;
    setSearchKey(value);
    if (value.startsWith(" ")) return;
    const filteredCommitteeList = committeeList?.filter((committee, index) =>
      committee?.committeeName.toLowerCase().includes(value?.toLowerCase()),
    );
    setSeacrhCommitteelist(filteredCommitteeList);
  };

  if (loader) return <CustomLoader />;
  return (
    <section className="bcsp-scommittee" id="bcsp-commissttee-slider">
      <div className="container">
        <div className="">
          <div className="committee-header">
            <div className="d-flex justify-content-between align-items-center w-100 search-bar-sec">
              <h2 className="main-title m-0 w-50">BPK Committees</h2>

              <form role="search" className="all-committee-search w-50">
                <input
                  name="search"
                  id="search"
                  type="text"
                  placeholder="Search..."
                  onChange={(e) => {
                    searchCommittees(e);
                  }}
                  maxLength={100}
                  value={searchKey}
                  aria-label="Search committees"
                  autoFocus
                />
                <i className="fa fa-search" aria-hidden="true"></i>
              </form>
            </div>
          </div>

          <div
            className="row"
          // onScroll={(e) => handleScroll(e)}
          // style={
          //   committeeList?.length > 1
          //     ? { maxHeight: "280px", overflowY: "auto" }
          //     : {}
          // }
          >
            {seacrhCommitteelist?.map((event, index) => {
              return (
                <div className="col-md-3 col-sm-6 col-12 mb-5" >
                  <button
                    role="button"
                    className="committee-card"
                    onClick={() => handleCardClick(event)}
                    tabIndex={0}
                    aria-label={`View ${event?.committeeName} details`}
                  >
                    <div className="card-icon">
                      <img
                        src={
                          event?.committeeImage
                            ? process.env.REACT_APP_API_IMAGE_URL +
                              event?.committeeImage
                            : CommitteeIcon
                        }
                        alt={
                          event?.committeeName
                            ? `${event.committeeName} logo`
                            : "Committee logo"
                        }
                      />
                    </div>
                    <div
                      className="card-title"
                      style={{
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                        whiteSpace: "normal",
                      }}
                    >
                      {event?.committeeName}
                    </div>
                  </button>
                </div>
              );
            })}
          </div>

          {/* Button */}

          <div className="div-center mt-4">
            <Link
              to="/Home"
              className="cta-button min-width-none"
              aria-label="Back to home page"
            >
              Back
              {/* <i className="csc-arrow-icon bi bi-arrow-left"></i> */}
              <i class="arrow-icon-btn bi bi-arrow-left"></i>
            </Link>
            {(isLoggedin === false || isLoggedin === null) && (
              <Link
                to="/register"
                style={{ minWidth: "160px" }}
                className="cta-button mx-3"
                aria-label="Register to get involved"
              >
                Get Involved
                <i className="bi bi-heart"></i>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ViewAllCommittees;
